<ion-content class="ion-padding">
  <ion-button (click)="close()" class="close" fill="clear" color="light" hidden>
    <ion-icon slot="icon-only" name="close"></ion-icon>
  </ion-button>
</ion-content>
